package format

import kotlin.math.roundToLong

fun formatRub(value: Double): String = "${formatInteger(value)} RUB"

fun formatHours(value: Double): String = formatNumber(value)

fun formatInput(value: Double): String {
    val rounded = value.roundToLong()
    return if (value == rounded.toDouble()) rounded.toString() else value.toString()
}

fun formatNumber(value: Double): String {
    val rounded = (value * 100.0).roundToLong() / 100.0
    return rounded.toString()
}

fun formatInteger(value: Double): String {
    return value.roundToLong().toString().reversed().chunked(3).joinToString(" ").reversed()
}
